import React from 'react';
import './week-calendar-header-cell.css';

const WeekCalendarHeaderCell = ({ ...props }) => {
    const { compact, selected, index, setDayPos, className = '' } = props;
    const isTime = className.includes('week-calendar-header-cell--time');

    return (
        <div
            className={
                'week-calendar-header-cell' +
                (compact ? ' week-calendar-header-cell-compact' : '') +
                (selected ? ' week-calendar-header-cell-selected' : '') +
                (className ? ` ${className}` : '')
            }
            onClick={() => !isTime && setDayPos && setDayPos(index)}
        >
            {props.children}
        </div>
    );
};

export default WeekCalendarHeaderCell;
